import { ArrowDownNarrowWide, ArrowUpNarrowWide } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { SORT_OPTIONS } from '@/lib/filters';
import type { LinkSortField, SortOrder } from '@/types/api';

export function SortControl({
  sort,
  order,
  onChange,
}: {
  sort: LinkSortField;
  order: SortOrder;
  onChange: (next: { sort: LinkSortField; order: SortOrder }) => void;
}) {
  const nextOrder: SortOrder = order === 'desc' ? 'asc' : 'desc';
  const orderLabel =
    sort === 'title'
      ? order === 'asc'
        ? 'A to Z'
        : 'Z to A'
      : order === 'desc'
        ? 'Newest first'
        : 'Oldest first';

  return (
    <div className="flex items-center gap-1.5">
      <Select
        value={sort}
        onValueChange={(value) => onChange({ sort: value as LinkSortField, order })}
      >
        <SelectTrigger className="h-9 w-[11.5rem]" aria-label={`Sort by ${sort}`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {SORT_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => onChange({ sort, order: nextOrder })}
        aria-label={`Sort direction: ${orderLabel}. Switch direction`}
        title={orderLabel}
      >
        {order === 'desc' ? (
          <ArrowDownNarrowWide aria-hidden="true" className="h-4 w-4" />
        ) : (
          <ArrowUpNarrowWide aria-hidden="true" className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
}
